import { get, postFormData } from "./api.service";

const base_url = "accounts/v1";

export const getAccountDetails = () => {
  return get(`${base_url}`);
};

export const createAccount = (data: object) => {
  return postFormData(`${base_url}`, data);
};

export const updateAccount = (data: object) => {
  return postFormData(`${base_url}`, {
    ...data,
    _method: "put",
  });
};

export const isAccountComplete = (account: any) => {
  if (!account) {
    return false;
  }

  const settings =
    typeof account?.settings === "string"
      ? JSON.parse(account?.settings)
      : account?.settings || {};

  const hasPhone = !!account.phone;
  const hasDocumentType = !!settings.document_type;
  const hasDocument = !!settings.document;

  const paymentMethods = settings.payment_methods || [];
  const emailFrequencyDays = settings.email_frequency_days || [];

  const hasPaymentMethods =
    Array.isArray(paymentMethods) && paymentMethods.length > 0;
  const hasEmailFrequencyDays =
    Array.isArray(emailFrequencyDays) && emailFrequencyDays.length > 0;

  const address = settings.address || {};
  const bank = settings.bank || {};

  const hasAddress =
    !!address.postal_code &&
    !!address.address &&
    !!address.number &&
    !!address.neighborhood &&
    !!address.state &&
    !!address.city;

  const hasBank =
    !!bank.code &&
    !!bank.agency &&
    !!bank.account &&
    !!bank.type &&
    !!bank.holder_name &&
    !!bank.holder_document;

  return (
    hasPhone &&
    hasDocumentType &&
    hasDocument &&
    hasPaymentMethods &&
    hasEmailFrequencyDays &&
    hasAddress &&
    hasBank
  );
};
